import React from "react";


import { useDispatch } from "react-redux";
import { TwDropzone, TwFormHelperText } from "../../../components/tailwind";
import { useTranslation } from "react-i18next";
import { getInitialsUrl } from "../../../helpers";

export default function BusinessProfileImgInput({ isOnBoarding = false, setFieldValue, values, errors = {} }) {

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [logo, setLogo] = React.useState(values.logo);
  const [coverPhoto, setCoverPhoto] = React.useState(values?.images && values?.images.length ? values?.images[0] : "");
  const [formErrors, setFormErrors] = React.useState({});

  React.useEffect(() => {
    setFieldValue("logo", logo);
    setFieldValue("coverPhoto", coverPhoto);
    setFieldValue("images", [coverPhoto]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logo, coverPhoto]);


  return (
    <div className={"flex flex-col place-items-start justify-start items-start md:max-w-lg"}>
      <div className={"my-3"}>
        <h6
          className={"text-xl sm:text-sm/6 md:text-base font-bold text-gray-500"}
        >
          {/* {t("inputFieldsTitle.yourLogo")} */}
          {/* <span className={"text-base sm:text-sm md:text-sm text-center text-gray-400"}>
            t("inputFieldsTitle.optional")
          </span> */}
        </h6>
      </div>
      <TwDropzone
        // label={"Your Logo"}
        variant={"profile"}
        uploadBtnText={t(values?.businessProfileType && values?.businessProfileType === 'individual' ? "inputFieldsTitle.changePic" : "inputFieldsTitle.addLogo")}
        name={"logo"}
        value={values.logo}
        errors={formErrors}
        onChange={(image) => {
          setLogo(image);
        }}
        isShowDeletBtn={true}
        onDelete={() => {
            if (values.businessName) {
            setLogo(getInitialsUrl(values.businessName));
          }
        }}
      />
      {(errors["logo"] || errors["photo"]) && (
        <TwFormHelperText error={true}>{errors["logo"] || errors["photo"]}</TwFormHelperText>
      )}
    </div>
  );
}
